'use client'

import { AppCustomizationSection } from './sections/app-customization-section'

export const AppCustomizationTab = () => {
    return (
        <div className="flex flex-col gap-6">
            <div>
                <h3 className="text-[16px] font-semibold text-[#171717]">App Customizations</h3>
                <p className="text-[13px] text-[#6B7280] mt-1">
                    Your settings are saved in this browser
                </p>
            </div>
            <AppCustomizationSection />
        </div>
    )
}
